// extracted by mini-css-extract-plugin
export default {"subscriptionTypeName":"SubscriptionList-module__subscriptionTypeName__isFzuVc"};